export default __webpack_public_path__ + "245ce5f3f41277bc952c31aaccfb144a.png";